import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import {
    getMaxMonthlyInterestRate,
    getProductTypeFromURL
} from '../../accountsSelector';
import { Rate } from '../../../ui/rate/Rate';
import { Tooltip } from '../../../ui/tooltip/Tooltip';
import { TooltipQuestionMarkSVG } from '../../../../svgComponents/tooltipQuestionMarkSVG/TooltipQuestionMarkSVG';

import messages from './LoanCost.messages';
import styles from './LoanCost.module.css';
import { RootState } from '@iwProvider/configureStore';

const mapStateToProps = (state: RootState) => ({
    approvalInterestRate: getMaxMonthlyInterestRate(
        state,
        getProductTypeFromURL()
    )
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const LoanCost = ({ approvalInterestRate }: PropsFromRedux) => (
    <>
        <FormattedMessage
            {...messages.youllPay}
            values={{
                approvalInterestRate: <Rate value={approvalInterestRate} />
            }}
        />
        <Tooltip
            className={styles.tooltip}
            message={<FormattedMessage {...messages.tooltip} />}
        >
            <TooltipQuestionMarkSVG className={`${styles.icon}`} />
        </Tooltip>
    </>
);

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(LoanCost);
